import {
  acceptanceViewInfoSelectors,
  useAcceptanceViewInfoQuery,
} from '../../../api/acceptanceViewInfo';
import { searchParamKeys } from '../../../shared/configs/searchParams';
import { useSearchParamsSelector } from '../../../shared/packages/searchParamsManager';
import { toInteger } from '../../../shared/packages/searchParamsNormalizer';
import { getBaseOptions } from '../helpers';

const dataTypes = {
  original: 'original',
  map: 'map',
};

const _options = {
  [dataTypes.original]: {},
  [dataTypes.map]: { select: acceptanceViewInfoSelectors.toMap },
};

export const useAcceptanceListInfo = ({
  options,
  dataType = dataTypes.original,
} = {}) => {
  const serviceCompanyId = useSearchParamsSelector((state) => {
    return toInteger(state[searchParamKeys.company]);
  });

  const baseOptions = getBaseOptions(_options, dataType, dataTypes.original);

  return useAcceptanceViewInfoQuery({
    params: { serviceCompanyId },
    options: { ...baseOptions, ...options },
  });
};

useAcceptanceListInfo.dataTypes = dataTypes;
